// Libraries
import React, { useRef, ReactNode } from "react";
import gsap from "gsap";
import { ScrollTrigger, Flip } from "gsap/all";
import { Col, Row } from "react-bootstrap";

gsap.registerPlugin(Flip, ScrollTrigger);

type TextCardProps = {
  classNames?: string;
  header?: string;
};

const SocialLinks: React.FC<TextCardProps> = ({ header, classNames}) => {
    const CardRef = useRef<HTMLDivElement | null>(null);
    const links = [
        {
            iconClass: "bi-instagram",
            url: "https://www.instagram.com/fattehmagazine"
        },
        {
            iconClass: "bi-facebook",
            url: "https://www.facebook.com/share/16Zpkotcc2/?mibextid=wwXIfr"
        },
    ]
  return (
    <Row className={`social-links-wrapper ${classNames}`} ref={CardRef}>
        <Col sm={12} md={7} className="social-links-header">
            {header && <h5>{header}</h5>}
        </Col>
        <Col sm={12} md={5} className="social-links">
            {links.map((link,id)=>(
                <a key={id}href={link.url} target="_blank" rel="noreferrer"><i className={`bi ${link.iconClass}`}></i></a>
            ))}
        </Col>
    </Row>
  );
};

export default SocialLinks;

